var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftpanelexpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.16406H3.5C2.94772 4.16406 2.5 4.61178 2.5 5.16406V14.8307C2.5 15.383 2.94772 15.8307 3.5 15.8307H7.5M7.5 4.16406H16.5C17.0523 4.16406 17.5 4.61178 17.5 5.16406V14.8307C17.5 15.383 17.0523 15.8307 16.5 15.8307H7.5M7.5 4.16406V15.8307",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftpanelexpand);
export default __webpack_public_path__ + "static/media/left panel expand.121617b2dbb9b871ceabd4efe9137c81.svg";
export { ForwardRef as ReactComponent };